import type {
  CardHeaderProps
} from '@chakra-ui/react'
import {
  CardHeader,
  forwardRef,
  Heading
} from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { RoundBadge } from '../../../components/RoundBadge'

export interface DashboardCardHeaderProps extends Omit<CardHeaderProps, 'title'> {
  title: ReactNode
  badge?: number | string
}

export const DashboardCardHeader = forwardRef(
  ({ children, title, badge }: DashboardCardHeaderProps, ref) => {
    return (
      <CardHeader
        ref={ref}
        sx={{ display: 'flex', gap: 8, px: { base: 4, md: 6 }, py: { base: 4, md: 6 }, alignItems: 'center' }}
      >
        <Heading sx={{ fontSize: 'lg', fontWeight: 'bold', w: 'full' }}>{title}</Heading>

        {!!badge && <RoundBadge>{badge}</RoundBadge>}
        {/* {badge && <Badge variant="solid" colorScheme="primary">{badge}</Badge>} */}
      </CardHeader>
    )
  },
)
